// Auto-generated per-query builders for SecurityScope
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { SecurityScopeReadAPI, SecurityScopeWriteAPI, SecurityScopeReadAPISchema, SecurityScopeWriteAPISchema } from '../types/securityscope';
import { ModelRegistry } from '../../registries/model-registry';
import { GroupAt, ParentScope } from '../../relationships/relationship';

import { Group } from '../../base/api/group';




// Include spec for query: BaseEffectiveRosterIncludeSpec
export interface BaseEffectiveRosterIncludeSpec {
  holders?: {
  };
  scope?: {
  };
}


// Builder chain for query: base-effective-roster

export interface BaseEffectiveRosterBuilder_0 {
  get(id: string): BaseEffectiveRosterBuilder_1;
  filter(conditions: { id: string }): BaseEffectiveRosterBuilder_1;
}

export interface BaseEffectiveRosterBuilder_1 {
  parent_scope: BaseEffectiveRosterBuilder_2;
}

export interface BaseEffectiveRosterBuilder_2 {
  groups: BaseEffectiveRosterBuilder_3;
}

export interface BaseEffectiveRosterBuilder_3 {
  load(include: BaseEffectiveRosterIncludeSpec): BaseEffectiveRosterBuilder_3;
  all(): Promise<Group[]>;
  first(): Promise<Group | null>;
  get(): Promise<Group[]>;
  execute(): Promise<Group[]>;
}


// Union of all query entry points
export type SecurityScopeQueryBuilder = BaseEffectiveRosterBuilder_0;

// Available query names for .setQuery()
export type SecurityScopeQueryNames = "base-effective-roster";

// Type narrowing for .setQuery()
export type SecurityScopeBuilderForQuery<Q extends SecurityScopeQueryNames> =
  Q extends "base-effective-roster" ? BaseEffectiveRosterBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type SecurityScopeInstanceQueryResult<Q extends SecurityScopeQueryNames> =
  Q extends "base-effective-roster" ? BaseEffectiveRosterBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  'parent_scope|groups': 'base-effective-roster',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends SecurityScopeQueryNames>(queryName: Q): SecurityScopeBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'groups', {
  get() {
    return new QueryBuilderImpl('Group', [...this.path, 'groups'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(QueryBuilderImpl.prototype, 'parent_scope', {
  get() {
    return new QueryBuilderImpl('SecurityScope', [...this.path, 'parent_scope'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface SecurityScope extends Partial<SecurityScopeReadAPI> {}
export class SecurityScope extends NeoNodeBase<SecurityScopeReadAPI, SecurityScopeWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "SecurityScope";
  static readonly readSchema = SecurityScopeReadAPISchema;
  static readonly writeSchema = SecurityScopeWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    parent_scope: { target: "SecurityScope", cardinality: "one", isParent: false, relClass: "ParentScope", direction: "out" },
    child_scopes: { target: "SecurityScope", cardinality: "many", isParent: false, relClass: "ParentScope", direction: "in" },
    groups: { target: "Group", cardinality: "many", isParent: false, relClass: "GroupAt", direction: "in" },
  };

  protected get modelName(): string {
    return 'SecurityScope';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return SecurityScope.label;
  }


  constructor(data: Partial<SecurityScopeWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: SecurityScopeReadAPI, loadContext?: Record<string, any>): SecurityScope {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { groups, parent_scope, child_scopes, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = SecurityScopeReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, groups: groups, parent_scope: parent_scope, child_scopes: child_scopes };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return SecurityScope.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'groups', 'Group', ModelRegistry);
    loadOneRelationship(processed, 'parent_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'child_scopes', 'SecurityScope', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new SecurityScope(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): SecurityScopeQueryBuilder {
    return new QueryBuilderImpl('SecurityScope').filter(conditions) as any;
  }

  static all(): SecurityScopeQueryBuilder {
    return new QueryBuilderImpl('SecurityScope') as any;
  }

  static async first(): Promise<SecurityScope | null> {
    const results = await new QueryBuilderImpl('SecurityScope').execute();
    return results[0] || null;
  }


  static setQuery<Q extends SecurityScopeQueryNames>(queryName: Q): SecurityScopeBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('SecurityScope');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends SecurityScopeQueryNames>(queryName: Q): SecurityScopeInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = SecurityScope.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'groups' - Python ORM style (cached)
  get groups(): RelationshipManager<this, Group> {
    return this.getOrCreateRelationshipManager('groups', () => {
      return new RelationshipManager(this, 'groups', 'many', GroupAt as typeof Relationship);
    });
  }

  // Relationship manager for 'parent_scope' - Python ORM style (cached)
  get parent_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('parent_scope', () => {
      return new RelationshipManager(this, 'parent_scope', 'one', ParentScope as typeof Relationship);
    });
  }

  // Relationship manager for 'child_scopes' - Python ORM style (cached)
  get child_scopes(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('child_scopes', () => {
      return new RelationshipManager(this, 'child_scopes', 'many', ParentScope as typeof Relationship);
    });
  }

}
